import React from 'react';

export default function Size() {
	return (
		<svg className="svg size" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm0 1.6c3.52 0 6.4 2.88 6.4 6.4 0 3.52-2.88 6.4-6.4 6.4-3.52 0-6.4-2.88-6.4-6.4 0-3.52 2.88-6.4 6.4-6.4Zm-.8 3.2 1.434 1.434-2.4 2.4L4.8 7.2v4h4L7.366 9.766l2.4-2.4L11.2 8.8v-4h-4Z" /></svg>
	);
}
